<template>
  <div class="table-container">
    <div class="table-header">
      <el-row :gutter="10">
        <el-col :span="10">
          <div class="table-title"><span></span>地址列表</div>
        </el-col>
        <el-col :span="14">
          <div class="table-button-container">
            <el-button type="success" @click="showAddress()">
              <el-icon><plus /></el-icon>新增地址
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="addresses" border>
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column prop="recCompanyName" label="收货公司"></el-table-column>
      <el-table-column prop="recName" label="收货人"></el-table-column>
      <el-table-column prop="recPhone" label="收货电话"></el-table-column>
      <el-table-column label="收货地址">
        <template #default="scope">
          {{scope.row.provinceName + (scope.row.cityName !== scope.row.provinceName ? scope.row.cityName : '') + scope.row.countyName + scope.row.address}}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-link type="primary" href="javascript:;" @click="showAddress(scope.row)">修改</el-link>
          <el-link type="primary" href="javascript:;" :disabled="scope.row.defaultAddress" @click="setDefault(scope.row)">默认收货地址</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" v-model:current-page="pageIndex" @size-change="handleSizeChange"
                   :page-size="pageSize" :total="total" :page-sizes="pageSizes" :pager-count="5"
                   background
                   layout="sizes, prev, pager, next, total"></el-pagination>
  </div>

  <el-dialog :title="address.sn ? '修改地址' : '新增地址'" v-model="saveAddressVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="address" ref="address">
      <el-form-item label="收货人" label-width="78px">
        <el-input type="text" v-model="address.recName"></el-input>
      </el-form-item>
      <el-form-item label="收货电话" label-width="78px">
        <el-input type="text" v-model="address.recPhone"></el-input>
      </el-form-item>
      <el-form-item label="收货地址" label-width="78px">
        <el-cascader ref="location" v-model="location" :props="locations" @change="locationChangeHandler"></el-cascader>
        <el-input type="text" v-model="address.address"></el-input>
      </el-form-item>
      <el-button type="primary" @click="saveAddress">确定</el-button>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "收货地址管理",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      pageSizes: [10, 20, 50],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      addresses: [],
      saveAddressVisible: false,
      address: {},
      locations: [],
      location: null
    }
  },
  methods: {
    list(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex
      }
      this.$apis.storeAddress.list(this.pageIndex - 1, this.pageSize, this.currentUser.sn).then(response => {
        this.addresses = response.data.data
        this.total = response.data.total
      })
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.list()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.list(1)
    },
    showAddress(address) {
      this.saveAddressVisible = true
      if (!address) {
        this.address = {
          recCompanySn: this.currentUser.sn
        }
        this.location = null
      } else {
        Object.assign(this.address, address)
        this.location = [address.provinceCode, address.cityCode, address.countyCode]
      }
    },
    saveAddress() {
      if (!this.address.recName) {
        this.$message.error('请输入收货人')
        return
      }
      if (!this.address.recPhone) {
        this.$message.error('请输入收货电话')
        return
      }
      if (!this.location || !this.address.address) {
        this.$message.error('请输入收货地址')
        return
      }
      if (!this.address.sn) {
        this.$apis.storeAddress.add(this.address).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '新增成功',
              type: 'success'
            })
            this.saveAddressVisible = false
            this.list()
          }
        })
      } else {
        this.$apis.storeAddress.edit(this.address).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.saveAddressVisible = false
            this.list()
          }
        })
      }
    },
    setDefault(address) {
      this.$apis.storeAddress.setDefault(address.sn).then(response => {
        if (response.status === 200) {
          this.$message({
            message: '默认地址设置成功',
            type: 'success'
          })
          this.list()
        }
      })
    },
    locationChangeHandler() {
      const node = this.$refs['location'].getCheckedNodes()
      this.address.provinceCode = node[0].pathValues[0]
      this.address.provinceName = node[0].pathLabels[0]
      this.address.cityCode = node[0].pathValues[1]
      this.address.cityName = node[0].pathLabels[1]
      this.address.countyCode = node[0].pathValues[2]
      this.address.countyName = node[0].pathLabels[2]
    },
    locationLazyLoad(node, resolve) {
      let _that = this
      if (node.level === 0) {
        _that.$apis.common.provinces().then(response => {
          const provinces = response.data
          let nodes = []
          provinces.forEach(item => {
            nodes.push({
              value: item.code,
              label: item.name,
              leaf: false
            })
          })
          resolve(nodes)
        })
      } else if (node.level === 1) {
        _that.$apis.common.cities(node.value).then(response => {
          const cities = response.data
          let nodes = []
          cities.forEach(item => {
            nodes.push({
              value: item.code,
              label: item.name,
              leaf: false
            })
          })
          resolve(nodes)
        })
      } else {
        _that.$apis.common.counties(node.value).then(response => {
          const counties = response.data
          let nodes = []
          counties.forEach(item => {
            nodes.push({
              value: item.code,
              label: item.name,
              leaf: true
            })
          })
          resolve(nodes)
        })
      }
    }
  },
  created() {
    this.list(1)
    this.locations = {
      lazy: true,
      lazyLoad: this.locationLazyLoad
    }
  }
}
</script>

<style scoped>

</style>